module.exports = __webpack_public_path__ + "media/images/front/banner_cds_sample_medicom-67e7ff42035b0deb81744c2d84e66345.png";